import React from 'react';

import { ColorPicker, UNSET, ValueBox, ValueGroup, ValueToggle } from '@candu-ai/craft/ui';
import { CRAFT_ROOT_ID } from 'craft/constants';
import { Section } from 'craft/containers/Toolbox/components';
import { getCssResetStyleMessage, StyleHierarchy, useCss, useResponsiveProps } from 'craft/hooks';
import { CssSelectorId } from 'craft/types';

export const OverlayBackdrop = () => {
  const {
    responsiveProps: { hideBackdrop },
    setResponsiveProps,
  } = useResponsiveProps([CRAFT_ROOT_ID]);

  const { css, setCss, stylesHierarchy } = useCss([CRAFT_ROOT_ID], {
    cssSelectorId: CssSelectorId.ModalBackdrop,
  });

  return (
    <Section name="Overlay Backdrop">
      <ValueGroup>
        <ValueBox label="Show Backdrop" isExpandable={{ isExpanded: !hideBackdrop }}>
          <ValueToggle
            onClick={() => {
              setResponsiveProps({ hideBackdrop: !hideBackdrop });
            }}
            isActive={!hideBackdrop}
          />
        </ValueBox>
        {!hideBackdrop && (
          <ColorPicker
            isInGroup={{ isLast: true }}
            value={css?.backgroundColor || stylesHierarchy?.backgroundColor?.fallbackValue}
            onResetTooltip={getCssResetStyleMessage(StyleHierarchy.Styleguide)}
            defaultValue={(stylesHierarchy?.backgroundColor?.fallbackValue as string) || UNSET}
            onChange={(backgroundColor: string) => setCss({ backgroundColor })}
          />
        )}
      </ValueGroup>
    </Section>
  );
};
